import { Component, OnInit } from '@angular/core';
import { CommonSettings } from 'epay-library';

@Component({
  selector: 'epay-secondary-registration',
  templateUrl: './secondary-registration.component.html'
})
export class EMPSecondaryRegistrationComponent implements OnInit {
  pagetitle = 'Employer: Complete Secondary Account Registration';
  baseurl: string;
  userEmailForLogin: boolean;

  constructor() {
    this.baseurl = CommonSettings.BaseApi;
    this.userEmailForLogin = CommonSettings.UseEmailForLogin;
   }

  ngOnInit() {
  }
}
